import { Trans, useTranslation } from "react-i18next";
import { Button } from "../../ui/button";

type Props = {
  code: string;
  helperText?: string;
  uri?: string;
  data?: Record<string, string>;
};

export const ServerErrorMessage = ({ code, helperText, uri, data }: Props) => {
  const { t } = useTranslation();

  if (!code) {
    return <p>{t("server_errors.unknown")}</p>;
  }

  return (
    <>
      <p>
        <Trans
          i18nKey={`server_errors.${code}` as any}
          values={{ ...data }}
          components={{ bold: <span className="font-semibold" /> }}
        />
      </p>
      {helperText && <p>{helperText}</p>} {helperText && <p>{helperText}</p>}
      {uri && (
        <Button
          className="underline font-semibold text-color-muted text-xs p-0"
          onClick={() => window.open(uri, "_blank")}
          variant="link"
        >
          {uri}
        </Button>
      )}
    </>
  );
};
